const version = "/v1";
const hire = "/hire";
export const apiEndpoint = {
  interviewDetails: hire + version + "/interviews/",
  interviewFeedback: hire + version + "/interview-feedbacks",
};
